import type { SupabaseGrabbit } from '$lib/supabase';
import type { Database } from '$lib/types/supabase';

export type Collection = Database['public']['Tables']['collection']['Row'];

export async function fetchCollections(
	supabase: SupabaseGrabbit
): Promise<Collection[]> {
	const { data } = await supabase.from('collection').select('*');

	return data ? data : [];
}

export async function fetchCollection(
	supabase: SupabaseGrabbit,
	policyId: string
): Promise<Collection | undefined> {
	const { data } = await supabase
		.from('collection')
		.select('*')
		.eq('policy_id', policyId)
		.single();

	if (data) {
		return data;
	}
}

function blankToNull(thing: Record<string, unknown>) {
	for (const [key, value] of Object.entries(thing)) {
		if (!value) {
			thing[key] = null;
		}
	}
}

export async function updateCollection(
	supabase: SupabaseGrabbit,
	collection: Collection
) {
	// Want to insert nulls instead of empty strings
	blankToNull(collection);

	const { data, error } = await supabase
		.from('collection')
		.update(collection)
		.eq('policy_id', collection.policy_id)
		.select()
		.single();

	if (error && !data) {
		throw Error(`Failed to update collection with error: ${error.message}`);
	}

	return data;
}
